import { render, staticRenderFns } from "./HeadeR.vue?vue&type=template&id=35e9cdc8&scoped=true&"
import script from "./HeadeR.vue?vue&type=script&lang=js&"
export * from "./HeadeR.vue?vue&type=script&lang=js&"
import style0 from "./HeadeR.vue?vue&type=style&index=0&id=35e9cdc8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e9cdc8",
  null
  
)

export default component.exports